/** @jsx jsx */

import React, { useContext } from 'react';
import { css, jsx } from '@emotion/core';
import { interactionContext as _interactionContext } from './interactionContext';
import { MultichoiceContext } from './Multichoice_v2';
import EditableBtn from 'components/lib/EditableBtn';

const SubmitBtn = props => {
  const { id, style = {}, children } = props;

  // contexts
  // const interactionContext = useContext(_interactionContext);
  const multichoiceContext = useContext(MultichoiceContext);

  const { isLive, submit, onSubmit } = multichoiceContext as any;

  // opacity: ${isLive ? 1 : submit > 0 ? 0.2 : 0};

  return (
    <div
      css={css`
        margin-top: 20px;
        ${!window.dev() &&
          `
          opacity: ${isLive ? 1 : 0};
          pointer-events: ${isLive ? 'auto' : 'none'};
          transition: opacity 0.2s;
        `}
      `}
    >
      <EditableBtn {...{ enabled: !!isLive, ...props }} onClick={onSubmit}>
        {children}
      </EditableBtn>
    </div>
  );
};

export default SubmitBtn;
